export const getLabelForDataPointModal = (openDataName) => {
  switch (openDataName) {
    case "firstTimeBuyer":
      return "Have you owned a home in the last 3 years?";
    case "propertyType":
      return "What type of property is it?";
    case "occupancyType":
      return "What kind of residence will this be?";
    case "isUsCitizen":
      return "Are you a U.S. citizen?";
    case "isVeteran":
      return "Are you a veteran?";
    case "isSelfEmployed":
      return "Are you self-employed?";
    case "hasRealEstateAgent":
      return "Working with a real estate agent?";
    case "isBuyingAsIs":
      return "Are you buying as-is?";
    case "forSaleByOwner":
      return "Is property for sale by owner?";
    case "hasTitleCompany":
      return "Do you have a title company?";
    case "hasWaivedEscrow":
      return "Do you want to waive escrow?";
    case "price":
      return "What's the property's cost?";
    case "existingLoanBalance":
      return "What's the loan balance?";
    case "takeCashOut":
      return "Would you like to take cash out?";
    case "amountOfCashOut":
      return "How much would you like to take out?";
    case "disabledVeteran":
      return "Are you a disabled veteran?";
    case "vaFirstTimeUse":
      return "Have you used a VA Loan Before?";
    case "lookAtVaLoans":
      return "Would you like to view VA Loans?";
    case "downPayment":
      return "What's the down payment?";
    case "creditScore":
      return "Edit credit score";
    case "plannedClosingDate":
      return "Edit planned closing date";
    case "loanOptions":
      return "Edit loan options";
    default:
      return "";
  }
};
